import type { Permission } from '@/data'
import api from '.'

export interface PermissionPayload {
  name: string
  guard_name?: string
}

export async function createPermission(
  payload: PermissionPayload,
): Promise<Permission> {
  const res = await api.post('/', payload)
  return res.data.data
}
